// extracted by mini-css-extract-plugin
export default {"carousel":"QuickFillCarousel_carousel__bEa6X"};